import TagDefaultProps from "segments/desktop/core-components/grid-tag/components/tag/default-props";
import FullParagraphDefaultProps from "segments/desktop/core-components/full-paragraph/default-props";

export default {
  tag: TagDefaultProps,
  fullParagraph: { ...FullParagraphDefaultProps, topic: "" }
};
